import { render } from "./BookMarks.vue?vue&type=template&id=6a6f5700&scoped=true"
import script from "./BookMarks.vue?vue&type=script&lang=js"
export * from "./BookMarks.vue?vue&type=script&lang=js"

import "./BookMarks.vue?vue&type=style&index=0&id=6a6f5700&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a6f5700"]])

export default __exports__